import React from "react";
import PrCard from "../PrCard";
import Section from "./Section";
import SectionHeading from "./SectionHeading";
import { heroPrs } from "./heroFixtures";

/**
 * Annotations grounded in lambda/shared/pr-analyzer.mjs's actual logic, not
 * paraphrase:
 *   - complexity: calculateComplexity() — 30% lines, 20% files, 30% critical
 *     paths touched, 20% file-type diversity.
 *   - tags: detectTags() — pattern-matched from file paths.
 *   - priority: calculatePriority() — tags.includes('security'|'auth') or
 *     complexity >= 8 forces 'critical'. This is the real mechanism behind
 *     what the plan called a "critical-file flag" — there's no separate
 *     badge for it, it surfaces through the priority label itself.
 *   - review time: estimateReviewTime() — lines + file-switching cost,
 *     scaled by complexity, clamped 5-120 minutes.
 */
const ANNOTATIONS = [
  {
    label: "Complexity score",
    body: "0–10, from lines changed, files touched, and critical-path detection. Computed from file paths and line counts alone — the diff is never read, never stored, never sent to a model.",
  },
  {
    label: "Estimated review time",
    body: "Calculated before anyone opens the diff — not guessed after the fact.",
  },
  {
    label: "Auto-detected tags",
    body: "Pulled from the files changed — auth, backend, database, and more — so reviewers know the shape of a change at a glance.",
  },
  {
    label: "Priority",
    body: "Anything touching auth, security, or payments is flagged critical automatically, so it can't get lost behind routine changes.",
  },
];

const FEATURED_PR = heroPrs[0];

export default function ComplexitySpotlight() {
  return (
    <Section id="complexity">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <div className="mx-auto w-full max-w-md">
          <PrCard pr={FEATURED_PR} />
        </div>

        <div>
          <SectionHeading
            eyebrow="The nutrition label"
            title="Every PR comes with one"
            align="left"
          />
          <dl className="mt-8 flex flex-col gap-6">
            {ANNOTATIONS.map((item) => (
              <div key={item.label}>
                <dt className="mb-1 text-sm font-semibold text-rf-text-primary">
                  {item.label}
                </dt>
                <dd className="text-sm leading-relaxed text-rf-text-secondary">{item.body}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </Section>
  );
}
